import { DEFAULT_LOCALE } from "./constants";

import type { SupportedLocale } from "./types";

const dayjsLocaleMap: Record<SupportedLocale, string> = {
  "pt-BR": "pt-br",
  "en-US": "en",
  "es-ES": "es",
};

export function formatNumber(value: number, locale: SupportedLocale = DEFAULT_LOCALE, options?: Intl.NumberFormatOptions) {
  return new Intl.NumberFormat(locale, options).format(value);
}

export function formatCurrency(value: number, locale: SupportedLocale = DEFAULT_LOCALE, currency = "BRL", options?: Intl.NumberFormatOptions) {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    ...options,
  }).format(value);
}

export function formatDate(
  value: Date | string | number,
  locale: SupportedLocale = DEFAULT_LOCALE,
  options?: Intl.DateTimeFormatOptions
) {
  const date = value instanceof Date ? value : new Date(value);
  return new Intl.DateTimeFormat(locale, options).format(date);
}

export function getDayjsLocale(locale: SupportedLocale = DEFAULT_LOCALE) {
  return dayjsLocaleMap[locale];
}
